import React, { useContext, useState, useEffect } from 'react'
import { Context } from "../../../Context"
import { AddSurveyView, AddOfferDataView, AddOfferCatalogView } from "../../views"
import { SimpleLoading, ModalUtil } from "../../pures"
import { CatalogService, SurveyService } from "../../../services"
import { AddSurveyIconFirst, AddPublicityIconSecond as AddSurveyIconSecond, AddSurveyIconThird } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"
import { useHistory } from 'react-router-dom'


const AddOfferAction = (props) => {
  const { t } = props
  const { t: translModal } = useTranslation('survey', { keyPrefix: 'modal' })
  const { t: transl } = useTranslation('survey', { keyPrefix: 'surveyAddValidations' })
  const apiUrl = process.env.REACT_APP_ETICKET_API
  const surveyService = new SurveyService(apiUrl)
  const catalogService = new CatalogService(apiUrl)
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [initialLoading, setInitialLoading] = useState(false)
  const [catalogInsert, setCatalogInsert] = useState([])
  const modalUtil = new ModalUtil()
  const history = useHistory()

  //first data
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [keyIdentifier, setKeyIdentifier] = useState('')
  const [endDate, setEndDate] = useState('')
  const [description, setDescription] = useState('')
  const [perVisit, setPerVisit] = useState(false)
  const [perBranch, setPerBranch] = useState(false)
  const [questions, setQuestions] = useState([{
    typeQuestionId: 1, name: '', edit: true, config: {
      maxCharacters: 120,
      minNum: 1,
      maxNum: 100,
      wholeNumber: false,
      required: false,
      minDate: new Date(),
      maxDate: new Date(),
      date: false,
      hour: false
    }
  }])

  //second data
  const [consumerPreferencesSelected, setConsumerPreferencesSelected] = useState([])
  const [gendersSelected, setGendersSelected] = useState([])
  const [agesSelected, setAgesSelected] = useState({ start: 10, end: 80 })
  const [branchOfficesSelected, setBranchOfficesSelected] = useState([])
  const [productsSelected, setProductsSelected] = useState([])

  const validationsFirstPage = () => {
    if (!name || !startDate || !endDate) throw new Error(transl('validationsInputFirstPage'))
    if (startDate > endDate) throw new Error(transl('datesValidation'))
  }

  const validationsSecondPage = () => {
    if (!consumerPreferencesSelected.length) throw new Error(transl('preferencesValidation'))
    if (!gendersSelected.length) throw new Error(transl('genderValidation'))
    if (agesSelected.start > agesSelected.end) throw new Error(transl('agesValidation'))
    if (!branchOfficesSelected.length) throw new Error(transl('branchOfficeValidation'))
  }

  const validationsThirdPage = () => {
    if (questions.length === 1 && questions[0].edit) throw new Error(transl('mustAddAQuestion'))

    for (let key in questions) {
      if (Number(key) + 1 !== questions.length) { // Evitar que la ultima pregunta se verifique ya que esta funciona como card para agregar y es una pregunta vacia.
        const question = questions[key]
        if (!question.name) throw new Error(transl('theQuestion') + (Number(key) + 1) + transl('notEmptyQuestion'))

        if (question.typeQuestionId === 2 && question.config.minNum > question.config.maxNum) throw new Error(transl('inTheQuestion') + (Number(key) + 1) + transl('quantityValidation'))

        if (question.typeQuestionId === 5 && question.config.minDate > question.config.maxDate) throw new Error(`${transl('inTheQuestion')}${Number(key) + 1} ${transl('datesValidation').toLowerCase()}`)

        if ([3, 4].includes(question.typeQuestionId) && question.questionOptions?.length < 2) throw new Error(transl('inTheQuestion') + (Number(key) + 1) + transl('addToOptions'))
      }
    }
  }

  const isValidInfoPage = (page) => {
    try {
      const tableValidations = {
        1: validationsFirstPage,
        2: validationsSecondPage,
        3: validationsThirdPage
      }

      tableValidations[page]()
      return true
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
      return false
    }
  }

  const changeQuestionOrder = (key, type) => {
    let keyAux = type === 'sum' ? key + 1 : key - 1

    let questionAux = [...questions]

    let temp = questionAux[key]
    questionAux[key] = questionAux[keyAux]
    questionAux[keyAux] = temp

    setQuestions(questionAux)
  }

  const sendData = async () => {
    modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

    try {
      const consumerPreferencesIds = consumerPreferencesSelected.map(({ id }) => id)
      const branchOfficesIds = branchOfficesSelected.map(({ id }) => id)
      const genderIds = gendersSelected.map((genderToShow) => {
        const genderObject = catalogInsert.gender.find((gendersSelected) => gendersSelected.name === genderToShow)
        return genderObject.id
      })

      const questionsToAdd = questions.filter((question) => question.name).map((question, key) => { return { ...question, order: key + 1 } })

      const body = {
        title: name,
        description,
        "minAge": agesSelected.start,
        "maxAge": agesSelected.end,
        startDate,
        endDate,
        perVisit,
        perBranch,
        consumerPreferencesIds,
        genderIds,
        "branchOfficeIds": branchOfficesIds,
        "questions": questionsToAdd // Avoid any empty question
      }


      const newSurvey = await surveyService.createSurvey(body, token)
      if (newSurvey && newSurvey.data && Number(newSurvey.statusCode) === 200) {
        modalUtil.showModal('success', translModal('successAdd'), t("modal.pure.title.success"), () => history.push('/surveys'))
      } else {
        modalUtil.showModal('error', translModal('errorAdd'), t("modal.pure.title.error"))
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        // Evita errores visuales
        modalUtil.showModal('error', error, t("modal.pure.title.error"))
      }, 100)
    }
  }

  const steps = [
    {
      image: AddSurveyIconFirst,
      title: 'Datos',
      next: 'Continuar',
      back: 'Salir',
    },
    {
      image: AddSurveyIconSecond,
      title: 'Documentos',
      next: 'Finalizar',
      back: 'Regresar',
    },
    {
      image: AddSurveyIconThird,
      title: 'Documentos',
      next: 'Finalizar',
      back: 'Regresar',
    },
  ]

  useEffect(() => {
    getCatalogInsert()
  }, [])

  const getCatalogInsert = async () => {
    try {
      const catalogInsert = await catalogService.getCatalogInsert(token, 'survey')
      setCatalogInsert(catalogInsert)
      setInitialLoading(false)
    } catch (error) {
      props.setShowError(true)
      setInitialLoading(false)
    }
  }

  // Funciones para survey

  const handleChangeQuestion = (ev, keyQuestion) => {
    setQuestions(questions.map((question, key) => key === keyQuestion ? { ...question, name: ev.target.value } : question))
  }

  const editQuestionOptions = (key, type, keyOption) => {
    let questionAux = questions[key]
    let questionOptionsAux = questionAux.questionOptions

    if (type === 'sum') {
      if (!questionOptionsAux) questionOptionsAux = []
      questionOptionsAux.push(questions[key].optionDropDown)
    } else if (type === 'subs') {
      questionOptionsAux.splice(keyOption, 1)
    }

    setQuestions(questions.map((question, keyQuestion) => key === keyQuestion ? { ...question, questionOptions: questionOptionsAux, optionDropDown: " " } : question))
  }

  const changeTypeQuestion = (key, typeQuestionIdSelected) => {
    let questionAux = questions

    questionAux = questionAux.map((question, elementKey) => {
      if (key === elementKey) {
        const { typeQuestionId, ...attributes } = question
        return { ...attributes, typeQuestionId: typeQuestionIdSelected }
      } else {
        return question
      }
    })

    setQuestions([...questionAux])
  }

  const deleteQuestion = (key) => {
    let questionAux = questions
    questionAux.splice(key, 1)

    questionAux = questionAux.map((question, key) => {
      const { order, ...attributes } = question
      return { ...attributes, order: key + 1 }
    })

    setQuestions(questionAux)
  }

  const handleChangeQuestionOption = (keyQuestion, keyOption, value) => {
    let questionsAux = [...questions]
    let optionsAux = [...questionsAux[keyQuestion].questionOptions]

    optionsAux[keyOption] = value
    questionsAux[keyQuestion] = { ...questionsAux[keyQuestion], questionOptions: optionsAux }

    setQuestions(questionsAux)
  }

  const handleOptionDropDown = (keyQuestion, value) => {
    setQuestions(questions.map((question, key) => key === keyQuestion ? { ...question, optionDropDown: value } : question))
  }

  const createNewQuestion = (key) => {
    const questionAux = questions.map((question, keyQuestion) => keyQuestion === key ? { ...question, edit: false } : question)
    if (key === questions.length - 1) questionAux.push({
      typeQuestionId: 1, name: '', edit: true, config: {
        maxCharacters: 120,
        minNum: 1,
        maxNum: 100,
        wholeNumber: false,
        required: false,
        minDate: new Date(),
        maxDate: new Date(),
        date: false,
        hour: false
      }
    })

    setQuestions(questionAux)
  }

  const setEditable = (key) => {
    setQuestions(questions.map((question, keyQuestion) => keyQuestion === key ? { ...question, edit: true } : question))
  }

  const handleChangeConfig = (key, value, keyIdentifier) => {
    setQuestions(questions.map((question, keyQuestion) => keyQuestion === key ? { ...question, config: { ...question.config, [keyIdentifier]: value } } : question))
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : (
            <AddSurveyView
              {...props}
              steps={steps}
              catalogInsert={catalogInsert}
              name={name}
              setName={setName}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              description={description}
              setDescription={setDescription}
              perVisit={perVisit}
              setPerVisit={setPerVisit}
              perBranch={perBranch}
              setPerBranch={setPerBranch}
              consumerPreferencesSelected={consumerPreferencesSelected}
              setConsumerPreferencesSelected={setConsumerPreferencesSelected}
              gendersSelected={gendersSelected}
              setGendersSelected={setGendersSelected}
              agesSelected={agesSelected}
              setAgesSelected={setAgesSelected}
              branchOfficesSelected={branchOfficesSelected}
              setBranchOfficesSelected={setBranchOfficesSelected}
              sendData={sendData}
              productsSelected={productsSelected}
              setProductsSelected={setProductsSelected}
              keyIdentifier={keyIdentifier}
              setKeyIdentifier={setKeyIdentifier}
              questionsFunctions={{
                handleChangeQuestion,
                editQuestionOptions,
                changeTypeQuestion,
                deleteQuestion,
                handleChangeQuestionOption,
                handleOptionDropDown,
                createNewQuestion,
                setEditable,
                handleChangeConfig,
                changeQuestionOrder
              }}
              questions={questions}
              isValidInfoPage={isValidInfoPage}
            >
            </AddSurveyView >
          )
      }
    </>
  )
}

function AddSurveyActionContainer(props) {
  const { t } = useTranslation()
  const { setShowError } = useContext(Context)
  return (
    <AddOfferAction {...props} t={t} setShowError={setShowError} />
  )
}

export { AddSurveyActionContainer as default }